import AppsList from './AppsList';

export default AppsList;
